import { buildModelManager } from "../builder.js";
const DefaultQaChartSelection = {
  __typename: true,
  id: true,
  canonicalRecord: true,
  chartIdentifiers: true,
  clinicianReleaseState: true,
  clinicianResponseThread: true,
  confidenceSummary: true,
  createdAt: true,
  createdById: true,
  deidentifiedArtifact: true,
  domainStates: true,
  domains: true,
  extractionResult: true,
  humanReviewSummary: true,
  institution: true,
  legacyQuickChartEvaluationId: true,
  notificationStatus: true,
  originalArtifactVaultObjectId: true,
  otherCrew: true,
  phiSafeguardStatus: true,
  portalStatus: true,
  primaryCaregiverExternalId: true,
  primaryCaregiverName: true,
  primaryCaregiverUserId: true,
  reviewStatus: true,
  routingSnapshot: true,
  secondaryCrewMemberExternalId: true,
  secondaryCrewMemberName: true,
  secondaryCrewMemberUserId: true,
  sourceMetadata: true,
  sourceReference: true,
  sourceType: true,
  specialistResults: true,
  status: true,
  synthesizedReport: true,
  thirdCrewMemberExternalId: true,
  thirdCrewMemberName: true,
  thirdCrewMemberUserId: true,
  title: true,
  updatedAt: true,
  uploadedArtifact: { url: true, mimeType: true, fileName: true },
  uploadedArtifactPayload: true,
  uploadedArtifactText: { markdown: true, truncatedHTML: true },
  visibilityPolicy: true,
  workflowHistory: true,
  workflowId: true
};
const modelApiIdentifier = "qaChart";
const pluralModelApiIdentifier = "qaCharts";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaChartSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaChartGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaChartManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaChartSelection,
  operations
);
export {
  DefaultQaChartSelection,
  QaChartManager
};
//# sourceMappingURL=QaChart.js.map
